import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AgentRoute, CreateAgentRouteDto, UpdateAgentRouteDto } from '../../models/forwarding/agent-route.model';

@Injectable({
  providedIn: 'root'
})
export class AgentRouteService {
  private apiUrl = `${environment.apiUrl}/forwarding/agent-routes`;
  private agentRoutesSubject = new BehaviorSubject<AgentRoute[]>([]);
  public agentRoutes$ = this.agentRoutesSubject.asObservable();

  constructor(private http: HttpClient) {
    this.loadAgentRoutes();
  }

  private loadAgentRoutes(): void {
    console.log('[AgentRouteService] Loading agent routes from:', this.apiUrl);
    this.http.get<AgentRoute[]>(this.apiUrl).subscribe({
      next: (routes) => {
        console.log('[AgentRouteService] Successfully loaded agent routes from API:', routes.length);
        this.agentRoutesSubject.next(routes);
      },
      error: (error) => {
        console.error('[AgentRouteService] Error loading agent routes from API:', error);
        this.agentRoutesSubject.next([]);
      }
    });
  }

  getAgentRoutes(): Observable<AgentRoute[]> {
    return this.agentRoutes$;
  }

  getById(id: number): Observable<AgentRoute> {
    return this.http.get<AgentRoute>(`${this.apiUrl}/${id}`);
  }

  getByAgentId(agentId: number): Observable<AgentRoute[]> {
    return this.http.get<AgentRoute[]>(`${this.apiUrl}/by-agent/${agentId}`);
  }

  create(dto: CreateAgentRouteDto): Observable<AgentRoute> {
    return this.http.post<AgentRoute>(this.apiUrl, dto).pipe(
      tap(() => {
        console.log('[AgentRouteService] Agent route created, reloading');
        this.loadAgentRoutes();
      })
    );
  }

  update(id: number, dto: UpdateAgentRouteDto): Observable<AgentRoute> {
    return this.http.put<AgentRoute>(`${this.apiUrl}/${id}`, dto).pipe(
      tap(() => {
        console.log('[AgentRouteService] Agent route updated, reloading');
        this.loadAgentRoutes();
      })
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      tap(() => {
        console.log('[AgentRouteService] Agent route deleted, reloading');
        this.loadAgentRoutes();
      })
    );
  }

  refresh(): void {
    this.loadAgentRoutes();
  }
}
